import React, { useEffect } from 'react';
import './convocatorias.css';

const Convocatorias = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    // Añadir clase para animar las tarjetas cuando la página carga
    const cards = document.querySelectorAll('.card');
    cards.forEach((card, index) => {
      setTimeout(() => {
        card.classList.add('card-loaded');
      }, index * 100); // Retardo entre la aparición de cada tarjeta
    });
  }, []);

  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Convocatorias</h3>
          <hr className='hr-gob' />
        </div>
      </div>

      <div className='row'>

        {/* Tarjeta 1 */}
        <div className='col-md-6 col-lg-4'>
          <div className='card'>
            <h4>13ª. EDICIÓN DEL CONCURSO ESTATAL DE ARTESANÍAS “HECHO EN HIDALGO 2026"</h4>
            <a
              href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2026/CONVOCATORIA_HECHO_EN_HIDALGO.pdf'
              target='_blank'
              rel='noopener noreferrer'
              className='card-title'
            >
              Convocatoria
            </a>
            <h5>Formatos</h5>
            <ol>
              <li>
                <a
                  href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2026/XIII_CEA/ANEXO_2.pdf'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Anexo 2
                </a>
                
              </li>
              <li>
                <a
                  href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2026/XIII_CEA/ANEXO_3.pdf'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Anexo 3
                </a>
                
              </li>
              <li>
                <a
                  href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2026/XIII_CEA/ANEXO_7.pdf'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Anexo 7
                </a>
                
              </li>
              <li>
                <a
                  href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2026/XIII_CEA/ANEXO_8.pdf'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Anexo 8
                </a>
                
              </li>
            </ol>
          </div>
        </div>

        {/* Tarjeta 2 */}
        <div className='col-md-6 col-lg-4'>
          <div className='card'>
            <h4>APOYOS ECONÓMICOS PARA RECONOCER LA TRAYECTORIA DE PERSONAS ARTESANAS 2026</h4>
            <a
              href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2026/CONVOCATORIA_PERSONAS_ARTESANAS.pdf'
              target='_blank'
              rel='noopener noreferrer'
              className='card-title'
            >
              Convocatoria
            </a>
            <h5>Formatos</h5>
            <ol>
              <li>
                <a
                  href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2026/AE_TPA/ANEXO_2.pdf'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Anexo 2
                </a>
                
              </li>
              <li>
                <a
                  href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2026/AE_TPA/ANEXO_3.pdf'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Anexo 3
                </a>
                
              </li>
              <li>
                <a
                  href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2026/AE_TPA/ANEXO_6.pdf'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Anexo 6
                </a>
                
              </li>
            </ol>
          </div>
        </div>



        {/* Tarjeta 1 */}
        <div className='col-md-6 col-lg-4'>
          <div className='card'>
            <h4>Convocatoria Xantolo 2025</h4>
            <a
              href='/assets/pdfs/CONV_Xant_2025.pdf'
              target='_blank'
              rel='noopener noreferrer'
              className='card-title'
            >
              Convocatoria
            </a>
            <h5>Formatos</h5>
            <ol>
              <li>
                <a
                  href='/assets/pdfs/ANEXOS.pdf'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Formatos
                </a>
              </li>
            </ol>
          </div>
        </div>

       

        {/* Tarjeta 1 */}
        <div className='col-md-6 col-lg-4'>
          <div className='card'>
            <h4>Apoyos Económicos Para Reconocer La Trayecctoria de Personas Artesanas</h4>
            <a
              href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2025/Convocatoria_Trayectoria_2025.pdf'
              target='_blank'
              rel='noopener noreferrer'
              className='card-title'
            >
              Convocatoria
            </a>
            <h5>Formatos</h5>
            <ol>
              <li>
                <a
                  href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2025/Formatos_Trayectoria_2025.pdf'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Formatos
                </a>
              </li>
            </ol>
          </div>
        </div>

         {/* Tarjeta 1 */}
        <div className='col-md-6 col-lg-4'>
          <div className='card'>
            <h4>8ᵃ Edición del Concurso Regional de Artesanías del Valle del Mezquital 2025</h4>
            <a
              href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2025/Convocatoria_VM_2025.pdf'
              target='_blank'
              rel='noopener noreferrer'
              className='card-title'
            >
              Convocatoria
            </a>
            <h5>Formatos</h5>
            <ol>
              <li>
                <a
                  href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2025/Anexos_VM_2025.pdf'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Anexos
                </a>
              </li>
            </ol>
          </div>
        </div>

        {/* Tarjeta 1 */}
        <div className='col-md-6 col-lg-4'>
          <div className='card'>
            <h4>17ᵃ Edición del Concurso Regional de Artesanías de la Región Otomí Tepehua</h4>
            <a
              href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2025/Conv_TPH_2025.pdf'
              target='_blank'
              rel='noopener noreferrer'
              className='card-title'
            >
              Convocatoria
            </a>
            <h5>Formatos</h5>
            <ol>
              <li>
                <a
                  href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2025/Anexos_TPH_2025.pdf'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Anexos
                </a>
              </li>
            </ol>
          </div>
        </div>

         {/* Tarjeta 1 */}
        <div className='col-md-6 col-lg-4'>
          <div className='card'>
            <h4>12ᵃ Edición del Concurso Regional de Artesanías de la Huasteca Hidalguense 2025</h4>
            <a
              href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2025/Convocatoria_HH_2025.pdf'
              target='_blank'
              rel='noopener noreferrer'
              className='card-title'
            >
              Convocatoria
            </a>
            <h5>Formatos</h5>
            <ol>
              <li>
                <a
                  href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2025/Anexos_HH_2025.pdf'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Anexos
                </a>
              </li>
            </ol>
          </div>
        </div>
        

         {/* Tarjeta 1 */}
        <div className='col-md-6 col-lg-4'>
          <div className='card'>
            <h4>Bienestar de Personas Cuidadoras de Personas con Discapacidad 2025</h4>
            <a
              href='/assets/pdfs/CONVOCATORIA_CUIDADORES_2025.pdf'
              target='_blank'
              rel='noopener noreferrer'
              className='card-title'
            >
              Convocatoria
            </a>
            <h5>Formatos</h5>
            <ol>
              <li>
                <a
                  href='/assets/pdfs/FUPS.pdf'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Formato Único de la Persona Solicitante
                </a>
              </li>
              <li>
                <a
                  href='/assets/pdfs/Carta_Solicitud_Gobernador.docx'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Solicitud de Apoyo dirigida al C. Gobernador con atención al titular de la Secretaría de Bienestar e Inclusión Social
                </a>
              </li>
              <li>
                <a
                  href='/assets/pdfs/Cuestionario_Cuidadores.docx'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Cuestionario de acredicación de la ayuda social
                </a>
              </li>
            </ol>
          </div>
        </div>
        


        {/* Tarjeta 1 */}
        <div className='col-md-6 col-lg-4'>
          <div className='card'>
            <h4>Programa de Fomento al Desarrollo de la Participación Social Para el Bienestar del Ejercicio Fiscal 2025</h4>
            <a
              href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/programas/convocatorias/2025/CONVOCATORIA_FOMENTO_2025.pdf'
              target='_blank'
              rel='noopener noreferrer'
              className='card-title'
            >
              Convocatoria
            </a>
            <h5>Formatos</h5>
            <ol>
              <li>
                <a
                  href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/programas/formatos/2025/Anexos_Fomento_2025.pdf'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Anexos
                </a>
              </li>
            </ol>
          </div>
        </div>
      
      {/* Tarjeta 1 */}
        <div className='col-md-6 col-lg-4'>
          <div className='card'>
            <h4>Programa Desarrollo Inclusivo 2025</h4>
            <a
              href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/programas/convocatorias/2025/CONVOCATORIA_DI_2025.pdf'
              target='_blank'
              rel='noopener noreferrer'
              className='card-title'
            >
              Convocatoria
            </a>
            <h5>Formatos</h5>
            <ol>
              <li>
                <a
                  href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/programas/formatos/2025/SOL_DI_2025.docx'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Formato Solicitud de Ingreso al Programa
                </a>
              </li>
              <li>
                <a
                  href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/programas/formatos/2025/CSE_DI_2025.pptx'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Formato Cuestionario Socioeconómico
                </a>
              </li>
              <li>
                <a
                  href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/programas/formatos/2025/PROY_DI_2025.docx'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Formato Proyecto
                </a>
              </li>
            </ol>
          </div>
        </div>

        {/* Tarjeta 3 */}
        <div className='col-md-6 col-lg-4'>
          <div className='card'>
            <h4>Convocatoria para participar en el pabellón artesanal y gastronómico de la Feria San Francisco Pachuca 2025</h4>
            <a
              href='/assets/pdfs/CONVOCATORIA_PABELLON_2025.pdf'
              target='_blank'
              rel='noopener noreferrer'
              className='card-title'
            >
              Convocatoria
            </a>
            <h5>Formatos</h5>
            <ol>
              <li>
                <a
                  href='/assets/pdfs/Anexos_Pabellon.pdf'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Anexos
                </a>
              </li>
            </ol>
          </div>
        </div>
        
        
       

        {/* Tarjeta 2 */}
        <div className='col-md-6 col-lg-4'>
          <div className='card'>
            <h4>Atención a Personas Migrantes 2025</h4>
            <a
              href='/assets/pdfs/CONVOCATORIA_MIGRANTES_2025.pdf'
              target='_blank'
              rel='noopener noreferrer'
              className='card-title'
            >
              Convocatoria
            </a>
          </div>
        </div>

        
      </div>
    </div>
  );
};

export default Convocatorias;
